import { fetchCustomerReviewSummary } from 'actions/ReviewActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import getObjectKey from 'lib/object/getObjectKey'
import { useEffect } from 'react'

type ReturnType = [
  App.ReviewSummary | undefined,
  boolean,
  any | undefined,
]

function useUserReviewsSummary(propertyId: string | undefined, propertyProvider: 'bedbank' | 'luxuryescapes'): ReturnType {
  const dispatch = useAppDispatch()

  const key = getObjectKey({ propertyId, propertyProvider })
  const summary = useAppSelector((state) => state.review.reviewSummaries[key])

  useEffect(() => {
    if (propertyId) {
      dispatch(fetchCustomerReviewSummary(propertyId, propertyProvider))
    }
  }, [dispatch, propertyId, propertyProvider])

  return [
    summary?.summary,
    summary?.fetching ?? !!propertyId,
    summary?.error,
  ]
}

export default useUserReviewsSummary
